<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item>聯絡我們</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          聯絡我們 <i class="far fa-envelope"></i> <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section style="padding-left: 16px;">
          <h3 style="margin-bottom: 22px;">農業部林業及自然保育署宜蘭分署</h3>
          <p>縣市：宜蘭縣</p>
          <p>地址：26548 宜蘭縣羅東鎮中正北路118號</p>
          <p>電話：03-9545114</p>
          <p>北緯(WGS84)：24.683462</p>
          <p>東經(WGS84)：121.773255</p>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  export default {
    name: 'contact',
    components: {
      HeaderSlide,
    },
    data() {
      return {
      }
    }
  }
</script>

<style>
  .accesskey-content{
    color: white;
  }
</style>